const walletWhite = require("./wallet_white.svg")
const walletBlue = require("./wallet_blue.svg")
const walletBlueBadge = require("./wallet_blue_badge.svg")
const walletGreenBadge = require("./wallet_green_badge.svg")
const walletRedBadge = require("./wallet_badge.svg")

export {
  walletWhite,
  walletBlue,
  walletBlueBadge,
  walletGreenBadge,
  walletRedBadge
}
